const posed = () => () => 'Posed';
posed.div = () => 'posed-div';

export const mockPose = {
  __esModule: true,
  default: posed,
};
